import React, { useState } from "react";
import "./MainLayout.css";
import LeftSideBar from "../../components/LeftSideBar";
import TopNavBar from "../../components/TopNavBar";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Footer from "../../components/Footer";

// SVG Icons for visual context (Simple SVGs used inline)

const MainLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const user =
    location.state?.user || JSON.parse(localStorage.getItem("user")) || {};

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/", { replace: true });
    window.location.reload();
  };
  console.log(user);

  return (
    <div className="dashboard-container">
      {/* Sidebar Component */}
      <LeftSideBar isOpen={isSidebarOpen} user={user} />

      <main className="main-content">
        {/* TopBar Component */}
        <TopNavBar
          toggleSidebar={() => setIsSidebarOpen(!isSidebarOpen)}
          onLogout={handleLogout}
          user={user}
        />

        {/* Page Content */}
        <div className="page-content">
          <Outlet />
        </div>
        <Footer />
      </main>

      {/* Overlay for mobile when sidebar is open */}
      {isSidebarOpen && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            zIndex: 900,
          }}
          onClick={() => setIsSidebarOpen(false)}
        ></div>
      )}
    </div>
  );
};

export default MainLayout;
